import { jsx } from "react/jsx-runtime";
import { SwitchStyled, SwitchThumbStyled } from "./Switch.styled";
const Switch = (props) => {
  return /* @__PURE__ */ jsx(SwitchStyled, { ...props, switchSize: "m", children: /* @__PURE__ */ jsx(SwitchThumbStyled, { switchSize: "m" }) });
};
var Switch_default = Switch;
export {
  Switch_default as default
};
